import "./AiToolsAIGenix.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import Aitools from "./sections/Aitools";
import Benefit from "./sections/Benefit";
import Faq from "./sections/Faq";
import Footer from "@/reusable_sections/Footer";
export default function AiToolsAIGenixPage() {
  return <div>
      <Header />
      <Hero />
      <Aitools />
      <Benefit />
      <Faq />
      <Footer />
    </div>;
}